export default {
  username: '用户名',
  password: '密码',
  confirm_password: '确认密码',
  reset_password: '重置密码',
  add_user: '新增用户',
  modify_pwd: '修改密码',
  modify_withdraw_type: '修改提现方式',
  pay_password_setting: '支付密码设置',
  second_after_regain: '秒后重新获取',
  verify: '验证',
  send_verification_code: '发送验证码',
  verification_code: '验证码:',
  login_email: '登录邮箱',
  authorized: '访问权限',
  authorized_status: '启动状态',
  authority: '权限',
  role: '角色',
  modify_auth: '修改权限',
  assign_role: '分配角色',
  modify_role: '编辑角色',
  mch_order_id: '用户唯一标识Id',
  payout_mch_order_id: '商户订单ID',
  amount: '付款金额',
  channel_code: '付款渠道',
  payout_status: '代付状态',
  refund_method: '退款方式',
  contact_details: '联系方式',
  customerService_email: '客服邮箱',
  customerService_phone_number: '客服电话',
  payment_amount_cents_tips: '代收金额，单位：分 例如{currency}:500.10, 需要设置50010 分',
  payment_amount_peso_tips: '代收金额，单位：比索 例如{currency}:500.10, 需要设置500.1 比索',
  payment_amount_tips: '代收金额，单位：分 例如{currency}:500.10, 需要设置50010分',
  payment_amount_tips_id: '代收金额，单位：元 例如{currency}:50010, 需要设置50010',
  reset_mfa: '重置 MFA',
  mfa_verify_code: 'MFA 验证码',
  mfa_code_required: 'MFA 验证码不能为空',
  mfa_status: 'MFA 状态',
  remark: '备注',
  role_name: '角色名称',
  add_role: '添加新角色',
  user_authentication: '身份认证',
  role_details: '角色详情',
  permissions: '权限',
  account_details: '账户详情',
  password_details: '密码详情',
  change_your_password: '更改您的密码',
  change_bank_info: '更改银行信息',
  change_withdraw_info: '更改提现信息',
  edit_bank: '编辑银行信息',
  bank_details: '银行详情',
  withdraw_details: '提现详情',
  copy_bank_passbook_wallet: '存折首页/钱包',
  business_permit: '商户注册附件',
  bir_registraon: '商户交税附件',
  certificate_authorized_representative: '受授权人签字',
  article_of_incorporation: '年审',
  withdraw_type: '提现类型',
  auto_withdraw_type: '自动提现方式',
  pos_withdraw_config_locked: '该商户为 POS 特殊提现商户，提现类型、自动提现方式、提现周期已由系统锁定，如需调整请联系客服',
  reviewing: '审核中',
  activated: '已激活',
  reject: '拒绝',
  dismiss: '驳回',
  dismiss_reason: '驳回原因',
  the_next_day: '下一天',
  handling_fee: '手续费',
  per_transaction: '每笔',
  update_role: '更新角色',
  kyc_unverified: '未认证',
  kyc_pending: '认证中',
  kyc_verified: '已认证',
  kyc_rejected: '审核驳回',
  notification_config: '通知配置',
  config: '配置',
  trade_daily_report_notification: '交易日报通知',
  send_trade_daily_notification: '每天固定时间发送交易日报通知',
  scheduled_send: '定时发送',
  send_time: '发送时间',
  send_test_email: '发送测试邮件',
  balance_alert_notification: '余额预警通知',
  balance_alert_description: '当余额小于设置的金额，发送通知',
  event_trigger: '事件触发',
  alert_amount: '预警金额',
  add_alert_amount: '添加预警金额',
  email_notification: '邮件通知',
  receive_notification: '站内通知:',
  send_test_notification: '发送测试通知',
  warn_amount: '预警金额',
  warn_amount_placeholder: '请输入预警金额',
  warn_amount_invalid: '请输入有效的预警金额',
  warn_amount_exists: '该预警金额已存在',
  warn_amount_duplicate: '多个预警金额不允许重复',
  warn_amount_min_error: '金额必须大于 0',
  warn_amount_max_error: '金额不能超过 999,999,999,999',
  add: '添加',
  add_warn_amount: '添加预警金额',
  save: '保存',
  cancel: '取消'
}
